export default __webpack_public_path__ + "static/media/footer-logo.b12c195a.png";